import type { AssistantContentRef } from "../../../../api/types/assistantTypes";

export const getContentKey = ({ type, id }: AssistantContentRef): string => `${type}:${id}`;

export const isSameContent = (content: AssistantContentRef, other: AssistantContentRef | undefined): boolean =>
  other !== undefined && content.type === other.type && content.id === other.id;
